import {getTopicTriggers, saveTrigger, addTrigger} from '../../services/EditorService';
import {assignStoryToTrigger, getRouteTriggers, doStoryFilesExist} from '../../services/TriggerService';

export default {
  namespaced: true,
  state: {
    triggersList: [],
    initialTrigger: {},
    currentTrigger: {},
    storyFiles: []
  },
  getters: {
    storyFiles: (state) => {
      return state.storyFiles;
    },
    triggersList: (state) => {
      return state.triggersList;
    },
    initialTrigger: (state) => {
      return state.initialTrigger;
    },
    currentTrigger: (state) => {
      return state.currentTrigger;
    },
    triggerEdited: (state) => {
      let edited = false;

      for (let [key, value] of Object.entries(state.currentTrigger)) {
        if (key !== 'name') {
          if (key === 'latLng') {
            if (String(state.initialTrigger[key].lat) !== String(value.lat)) {
              edited = true;
            }
            if (String(state.initialTrigger[key].lng) !== String(value.lng)) {
              edited = true;
            }
          } else if (typeof state.initialTrigger[key] === 'number') {
            if (state.initialTrigger[key] !== parseFloat(value)) {
              edited = true;
            }
          } else {
            if (state.initialTrigger[key] !== value) {
              if (key === 'heading') {
                if (parseFloat(state.currentTrigger.tolerance) < 360) {
                  edited = true;
                }
              } else {
                edited = true;
              }
            }
          }
        }
      }

      return edited;
    },
    headingEnabled: (state) => {
      return parseFloat(state.currentTrigger.tolerance) < 360;
    }
  },
  mutations: {
    updateLanguageOrderForTour (state, data) {
      state.triggersList = data.triggersList;
    },
    loadStoryFiles (state, storyFiles) {
      state.storyFiles = storyFiles;
    },
    loadTriggers (state, triggers) {
      for (let trigger of triggers) {
        if (trigger.latLng) {
          trigger.latLng = JSON.parse(trigger.latLng);
        }
        if (parseInt(trigger.heading) === -1) {
          trigger.heading = '0';
        }
        trigger.tolerance = (parseFloat(trigger.tolerance) * 2).toString();
        trigger.hovered = false;
      }
      state.triggersList = triggers;
    },
    setTrigger (state, trigger) {
      state.initialTrigger = Object.assign({}, trigger);
      state.currentTrigger = Object.assign({}, trigger);
      state.initialTrigger.latLng = Object.assign({}, trigger.latLng);
      state.currentTrigger.latLng = Object.assign({}, trigger.latLng);
    },
    addTrigger (state, trigger) {
      state.triggersList.push(trigger);
    },
    clearCurrentAndInitialTriggers (state) {
      state.currentTrigger = Object.assign({}, {});
      state.initialTrigger = Object.assign({}, {});
    },
    clearTriggersList (state) {
      state.triggersList = [];
    },
    setNewCurrentTriggerLatLng (state, latLng) {
      state.currentTrigger.latLng = latLng;
    },
    toggleTriggerHovered (state, payload) {
      if (payload.id) {
        for (let [index, value] of state.triggersList.entries()) {
          if (value.id === payload.id) {
            payload.index = index;
          }
        }
      }
      state.triggersList[payload.index].hovered = payload.hovered;
      state.triggersList[payload.index]['triggerName'] = payload.triggerName;
    },
    updateTriggerInList (state, trigger) {
      for (let [index, value] of state.triggersList.entries()) {
        if (value.id === trigger.id) {
          state.triggersList[index] = trigger;
        }
      }
    },
    removeMapTriggersFromState (state, topicId) {
      var triggers = state.triggersList;
      var triggersLength = triggers.length;
      for (var i = 0; i < triggersLength; i++) {
        if (triggers[i].toiId === topicId) {
          if (i === 0) {
            triggers = triggers.slice(1);
          } else if (i === triggers.length - 1) {
            triggers = triggers.slice(0, triggers.length - 1);
          } else {
            triggers = triggers.slice(0, i).concat(triggers.slice(i + 1));
          }
          i--;
          triggersLength--;
        }
      }
      state.triggersList = triggers;
    },
    setMapHoverTrigger (state, indexAndToggle) {
      var index = indexAndToggle[0];
      var toggle = indexAndToggle[1];
      state.triggersList[index].mapHover = toggle;
    },
    setNewCurrentTriggerHeadingRadius (state, payload) {
      state.currentTrigger.heading = payload.heading;
      state.currentTrigger.radiusDistance = payload.radius;
    },
    setCurrentTriggerTolerance (state, tolerance) {
      state.currentTrigger.tolerance = tolerance;
    },
    resetTriggerHover (state) {
      for (let trigger of state.triggersList) {
        trigger.hovered = false;
      }
    }
  },
  actions: {
    async assignStoryFiles ({commit}, data) {
      let response = await doStoryFilesExist(data);
      commit('loadStoryFiles', response.data);
    },
    async assignStory ({commit}, data) {
      let response = await assignStoryToTrigger(data);
      response = await getRouteTriggers(data.routeId);
      commit('loadTriggers', response.data);
    },
    updateTriggerZoneOrder ({commit}, data) {
      commit('updateLanguageOrderForTour', data);
    },
    async loadTriggerList ({commit}, payload) {
      const result = await getTopicTriggers(payload.routeId, payload.topicId);
      if (result.data.success) {
        commit('loadTriggers', result.data.triggers);
        for (let trigger in result.data.triggers) {
          commit('setTriggerStory', {triggerId: trigger.id, storyId: trigger.storyId});
        }
      } else {
        console.log(result.data.errors);
      }
    },
    setCurrentTrigger ({commit}, trigger) {
      commit('setTrigger', trigger);
    },
    setMapHoverTrigger ({commit}, indexAndToggle) {
      commit('setMapHoverTrigger', indexAndToggle);
    },
    async addNewTrigger ({commit}, trigger) {
      trigger.latLng = JSON.stringify(trigger.latLng);
      trigger.on_off = 1;
      trigger.priority = 0;
      trigger.tolerance = Math.round(trigger.tolerance / 2 * 100) / 100;
      const result = await addTrigger(trigger);
      if (result.data.success) {
        trigger.id = result.data.triggerId;
        trigger.latLng = JSON.parse(trigger.latLng);
        trigger.tolerance = (parseFloat(trigger.tolerance) * 2).toString();
        commit('setTrigger', trigger);
        commit('addTrigger', trigger);
      } else {
        console.log(result.data.errors);
      }
    },
    async saveTriggerZone ({commit}, trigger) {
      trigger.latLng = JSON.stringify(trigger.latLng);
      trigger.heading = (parseFloat(trigger.tolerance) < 360 ? Math.round(trigger.heading * 100) / 100 : -1);
      trigger.radiusDistance = Math.round(trigger.radiusDistance * 100) / 100;
      trigger.tolerance = Math.round(trigger.tolerance / 2 * 100) / 100;

      const result = await saveTrigger(trigger);
      if (result.data.success) {
        trigger.latLng = JSON.parse(trigger.latLng);
        trigger.hovered = false;
        commit('updateTriggerInList', trigger);
      } else {
        console.log(result.data.errors);
      }
    },
    clearCurrentTrigger ({commit}) {
      commit('clearCurrentAndInitialTriggers');
    },
    clearStateTriggersList ({commit}) {
      commit('clearTriggersList');
    },
    updateCurrentTriggerLatLng ({commit}, latLng) {
      commit('setNewCurrentTriggerLatLng', latLng);
    },
    toggleTriggerHovered ({commit}, payload) {
      commit('toggleTriggerHovered', payload);
    },
    async removeMapTriggersFromState ({commit}, topicId) {
      commit('removeMapTriggersFromState', topicId);
    },
    async loadRouteTriggers ({commit}, routeId) {
      const result = await getRouteTriggers(routeId);
      if (result.status === 200) {
        commit('loadTriggers', result.data);
      } else {
        console.log('Get triggers for route failed: ' + result);
      }
    },
    updateCurrentTriggerHeadingRadius ({commit}, payload) {
      commit('setNewCurrentTriggerHeadingRadius', payload);
    },
    updateCurrentTriggerTolerance ({commit}, newTolerance) {
      // This if block controls the min-max limits of the map marker handle to adjust trigger tolerance
      if (newTolerance > 359) {
        newTolerance = 359;
      } else if (newTolerance < 30) {
        newTolerance = 30;
      }
      commit('setCurrentTriggerTolerance', newTolerance);
    },
    resetTriggerHover ({commit}) {
      commit('resetTriggerHover');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/triggersModule.js